<template>
  <div class="wrapper">
    <div class="body-2 mb-1">
      {{ coachType == "club" ? "Club: " : "High School: " }}
      {{ clubOrHighschool.name }}
    </div>

    <template v-if="isLoggedIn">
      <h1 class="headline mb-2 mt-4">Add Transaction</h1>

      <v-select
        v-model="transaction"
        :items="transactions"
        :item-text="getTransactionText"
        placeholder="Transaction"
        return-object
        class="flex-grow-0 mb-2"
        clearable
        outlined
        dense
      ></v-select>
    </template>

    <h1 class="headline mb-8">Add your team</h1>

    <template
      v-if="
        $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'
      "
    >
      <v-expansion-panels id="panel">
        <v-expansion-panel
          v-for="(form, index) in athleteForms"
          :key="form.formId"
        >
          <v-expansion-panel-header
            class="d-flex align-center pa-4"
            id="panel-header"
          >
            <div class="body-1" :class="{ 'error--text': form.hasError }">
              {{ index + 1 }}. Item
              <span v-if="form.hasError">*</span>
            </div>

            <template v-slot:actions class="order-0">
              <v-icon>$expand</v-icon>
            </template>

            <v-btn
              icon
              small
              class="mt-1 flex-grow-0 order-1 mb-1 ml-1"
              v-if="athleteForms.length > 1"
              @click="deleteAthleteForm(index, form.formId)"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-expansion-panel-header>

          <v-expansion-panel-content class="pb-0" eager>
            <AthleteForm
              :positions="positions"
              :graduationYears="graduationYears"
              :index="index"
              :formId="form.formId"
              @athleteFormData="onAthleteFormData"
              :duplicateEmails="duplicateEmails"
              @recalcDuplicateEmails="onRecalcDuplicateEmails"
              @setErrorState="onSetErrorState"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>

    <template v-else>
      <div
        class="align-self-stretch d-flex"
        v-for="(form, index) in athleteForms"
        :key="form.formId"
      >
        <AthleteForm
          :positions="positions"
          :graduationYears="graduationYears"
          :index="index"
          :formId="form.formId"
          @athleteFormData="onAthleteFormData($event, form.formId)"
          :duplicateEmails="duplicateEmails"
          @recalcDuplicateEmails="onRecalcDuplicateEmails"
        />

        <v-btn
          icon
          small
          class="mt-1"
          v-if="athleteForms.length > 1"
          @click="deleteAthleteForm(index, form.formId)"
        >
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </div>
    </template>

    <v-btn
      color="primary"
      small
      text
      class="align-self-start mt-3 mb-5"
      @click="addAthleteForm"
    >
      <v-icon small left>mdi-account-plus</v-icon>Add athlete
    </v-btn>

    <v-btn
      color="primary"
      large
      class="mt-auto"
      @click="triggerSubmission"
      :loading="loader"
      >Submit</v-btn
    >
  </div>
</template>

<script>
import AthleteForm from "@/components/AthleteForm";
import store from "@/store";
import { db } from "../db";
import * as shortid from "shortid";
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";

export default {
  components: {
    AthleteForm,
  },
  data() {
    return {
      athleteForms: [{ formId: shortid.generate(), hasError: false }],
      positions: [],
      graduationYears: [],
      successfulSubmissions: [],
      duplicateEmails: [],
      loader: false,
      snackbar: false,
      transactions: [],
      transaction: null,
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.isLoggedIn,
      coachInfo: (state) => state.coachInfo,
      coachType: (state) => state.coachType,
      clubOrHighschool: (state) => state.clubOrHighschool,
    }),
  },
  created() {
    const currentYear = new Date().getFullYear();
    const range = (start, stop, step) =>
      Array.from(
        { length: (stop - start) / step + 1 },
        (_, i) => start + i * step
      );
    this.graduationYears = range(currentYear, currentYear + 5, 1);

    db.collection("positions")
      .get()
      .then((res) => {
        this.positions = res.docs.map((position) => {
          return {
            id: position.id,
            name: position.data().name,
            ref: position.ref,
          };
        });
      });

    if (this.isLoggedIn) {
      this.$bind("transactions", db.collection("mangoPay"));
    }
  },
  methods: {
    ...mapActions(["submit"]),
    ...mapMutations(["openSnackbar", "clearState"]),
    addAthleteForm() {
      this.athleteForms.push({ formId: shortid.generate(), hasError: false });
    },
    deleteAthleteForm(index, formId) {
      const found = this.athleteForms.findIndex(
        (form) => form.formId == formId
      );

      if (found != -1) {
        this.successfulSubmissions.splice(found, 1);
        this.$delete(this.athleteForms, index);
        this.findDuplicateEmails();
      }
    },
    onAthleteFormData(athleteFormData) {
      const found = this.successfulSubmissions.findIndex(
        (form) => form.formId == athleteFormData.formId
      );

      if (found != -1) {
        this.successfulSubmissions[found] = athleteFormData;
      } else {
        this.successfulSubmissions.push(athleteFormData);
      }
    },
    triggerSubmission() {
      this.successfulSubmissions = [];
      this.$emit("triggerSubmission");
    },
    findDuplicateEmails() {
      this.duplicateEmails = [];

      this.successfulSubmissions.forEach((athleteToSearch) => {
        this.successfulSubmissions.forEach((athlete) => {
          if (
            athleteToSearch.email === athlete.email &&
            athleteToSearch.formId != athlete.formId
          ) {
            if (!this.duplicateEmails.includes(athlete.formId))
              this.duplicateEmails.push(athlete.formId);
          }
        });
      });
    },
    onRecalcDuplicateEmails(data) {
      const found = this.successfulSubmissions.findIndex(
        (form) => form.formId == data.formId
      );

      if (found != -1) {
        this.successfulSubmissions[found].email = data.email;
        this.findDuplicateEmails();
      }
    },
    onSetErrorState(data) {
      const found = this.athleteForms.findIndex(
        (form) => form.formId == data.formId
      );

      if (found != -1) {
        this.athleteForms[found].hasError = data.hasError;
      }
    },
    getTransactionText(transaction) {
      return `${transaction.email} - $${transaction.price} - ${moment(
        transaction.expirationDate
      ).format("DD/MM/YY")}`;
    },
  },
  watch: {
    successfulSubmissions() {
      if (this.successfulSubmissions.length == this.athleteForms.length) {
        this.findDuplicateEmails();

        if (this.duplicateEmails.length == 0) {
          let payload = {
            coachInfo: {},
            athletes: [],
          };

          payload.coachInfo = {
            ...this.coachInfo
          };

          if (this.transaction) {
            payload.coachInfo.transactionIdentifier = this.transaction?.id
          }

          payload.coachInfo[
            this.coachType == "club" ? "club" : "highSchool"
          ] = this.clubOrHighschool.id;

          payload.athletes = this.successfulSubmissions.map((athlete) => {
            return {
              firstName: athlete.firstName,
              lastName: athlete.lastName,
              email: athlete.email,
              phone: athlete.mobile,
              parentEmail: athlete.parentEmail,
              graduatingYear: athlete.gradYear,
              position: athlete.position,
              ...(athlete.jerseyNum
                ? { clubJerseyNumber: parseInt(athlete.jerseyNum, 10) }
                : {}),
              ...(this.coachType == "club"
                ? { club: this.clubOrHighschool.id }
                : { highSchool: this.clubOrHighschool.id }),
              ...(this.isLoggedIn && this.transaction
                ? {
                    receipt: {
                      device: "mangoPay",
                      expirationDate: this.transaction.expirationDate,
                      transactionIdentifier: this.transaction.id,
                    },
                  }
                : {}),
            };
          });

          this.loader = true;
          this.submit(payload)
            .then(() => {
              this.loader = false;
              this.$router.push({ path: "/fourth" });
            })
            .catch(() => {
              this.loader = false;
              this.openSnackbar("error");
              this.$router.push({ path: "/" });
              this.clearState();
            });
        }
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (
      store.state.coachType &&
      store.state.clubOrHighschool &&
      store.state.coachInfo
    ) {
      next();
    } else {
      next("/");
    }
  },
};
</script>

<style lang="scss" scoped>
#panel-header {
  height: 48px;
}
</style>